import { FC, useMemo } from "react";

import { copy } from "shared/assets";
import { Equipment, Image, Venue } from "shared/assets/icons";
import { EditBlock as Component } from "shared/components";
import { ILocalStorageKey } from "shared/types";
import { VENUE_PATHS } from "Venues/router";
import { useVenuePageContext } from "Venues/contexts";
import { useVenueRoute } from "Venues/utils";

const { edit } = copy.venuePage;

export const EditBlock: FC = () => {
  const { getPath } = useVenueRoute();
  const { venueId, brandColor } = useVenuePageContext();

  const items = useMemo(
    () => [
      {
        icon: Image,
        to: getPath(VENUE_PATHS.EDIT_VENUE_BRANDING),
        label: edit.branding,
      },
      {
        icon: Venue,
        to: getPath(VENUE_PATHS.CREATE_VENUE_STAGE),
        label: edit.stage.long,
      },
      {
        icon: Equipment,
        to: getPath(VENUE_PATHS.EDIT_VENUE_EQUIPMENT),
        label: edit.equipment.long,
      },
    ],
    [getPath]
  );

  return (
    <Component
      items={items}
      id={venueId}
      cardAccentColor={brandColor}
      cardTitle={edit.title}
      cardIcon={Venue}
      localStorageKey={ILocalStorageKey.hideVenueEdit}
    />
  );
};
